import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-two-line-icon",
  "use": "icon-two-line-icon-usage",
  "viewBox": "0 0 16 8",
  "content": "<symbol viewBox=\"0 0 16 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-two-line-icon\">\n<rect width=\"16\" height=\"3\" rx=\"1.5\" fill=\"currentColor\" />\n<rect y=\"5\" width=\"16\" height=\"3\" rx=\"1.5\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol